import { InstanceScreen } from 'component/navigation/instance';
import { Stack, useLocalSearchParams } from 'expo-router';

export default function ModerationDashboardSpacesSpaceScreen() {
    const { instanceKey } = useLocalSearchParams<'/[siloKey]/moderationdash/one/spaces/[instanceKey]'>();
    return (
        <>
            <Stack.Screen options={{ title: instanceKey }} />
            <InstanceScreen params={{ structureKey1: 'question', instanceKey1: instanceKey }} screenKey='spaces/[instanceKey]' />
        </>
    );
}
